import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchDictionary} from "../../core/actions/DictionaryActions";
import {getUser} from "../../core/actions/UserActions";
import {fetchCountryIsoCode} from "../../core/actions/CountryActions";
import {userIsGuest} from "../../core/helpers/UserHelper";
import AuthTabs from "../../core/components/auth/tabs/AuthTabs";

function Index() {
    const user = useSelector(state => state.user)
    const {signUpEnabled} = useSelector(state => state.site);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUser());
        dispatch(fetchDictionary());
        dispatch(fetchCountryIsoCode());
    }, []);

    if (!userIsGuest(user)) {
        window.location = '/account/';
    }

    return <div className="wrapper-holder">
        <div className="main-holder">
            <div className="content">
                <div className="block inner">
                    <AuthTabs signUpEnabled={signUpEnabled} />
                </div>
            </div>
        </div>
    </div>
}

export default Index